module.exports = __webpack_public_path__ + "static/img/icon_wechatmini_gzh_title.da77163.png";


//////////////////
// WEBPACK FOOTER
// ./src/projects/hsbpc/views/welcome/components/img/icon_wechatmini_gzh_title.png
// module id = 2aCh
// module chunks = 1